import { IApiStore } from '@core/api/apiStore';
import { EndpointCallParams } from '@core/api/endpointCallParams';


type DownloadFileParams = {
    id: string;
}


export const performDownloadDownloadables = async (api: IApiStore, params: EndpointCallParams<DownloadFileParams>) => {
    const { payload, ...rest } = params;
    const result = await api
        .get('contentfileprovider-app/api/v1/FileProvider/DownloadableVersionFile', {
            ...rest,
            payload,
        });

    return result;
}
